import e from "react";
import { IconElement as r } from "../icon-element/icon-element.esm.js";
import o from "../icon/src/PendingSimple.esm.js";
const n = () => /* @__PURE__ */ e.createElement(
  r,
  {
    icon: /* @__PURE__ */ e.createElement(o, null),
    color: "var(--color-greys-grey7)",
    responsiveSize: "medium",
    "aria-hidden": "true"
  }
);
export {
  n as Ellipses
};
